const zenGarden = {
  id: "zen-garden",
  displayName: "Jardín Zen",

  atmosphere: {
    sky: "#151529",
    fog: { near: 30, far: 110 },
    exposure: 1.1,
    stars: { count: 700, color: "#dfe8ff", size: 1.6 },
    hemisphereLight: { sky: "#35406b", ground: "#10141f", intensity: 0.6 },
    moon: {
      color: "#bdd2ff",
      intensity: 0.9,
      position: [-26, 40, -16],
      shadowMapSize: 2048,
      shadowBias: -0.0004,
      shadowMargin: 12,
    },
  },

  materials: {
    ground: { color: "#2f4a3e", roughness: 1 },
    hedge: { color: "#27412f", roughness: 1 },
    stone: { color: "#59637a", roughness: 0.9 },
    stoneDark: { color: "#47506a", roughness: 0.95 },
    rock: { color: "#59637a", roughness: 1, flatShading: true },
    wood: { color: "#6b4f3a", roughness: 0.85 },
    toriiWood: { color: "#7a4040", roughness: 0.8 },
    lanternWindow: { color: "#66513a", roughness: 0.6 },
    lanternGlow: "#ffb26b",
  },

  arena: {
    floorRadius: 34,
    floorSegments: 56,
    halfExtent: 30,
    wallHeight: 3.2,
    wallThickness: 1.6,
    cornerPost: { size: [2.2, 3.8, 2.2] },
  },

  spawns: {
    players: [
      [0, 0.5, -24],
      [-24, 0.5, 0],
      [24, 0.5, 4],
      [6, 0.5, 24],
    ],
    waypoints: [
      [20, 0, 0],
      [-20, 0, 0],
      [0, 0, 20],
      [0, 0, -20],
      [14, 0, 14],
      [-14, 0, 14],
      [14, 0, -14],
      [-14, 0, -14],
      [8, 0, 0],
      [-8, 0, 0],
      [0, 0, 9],
      [0, 0, -9],
      [22, 0, -8],
      [-22, 0, 6],
    ],
  },

  entities: [
    {
      type: "platform",
      position: [0, 0.3, 0],
      radiusTop: 6,
      radiusBottom: 6.4,
      height: 0.6,
      material: "stone",
    },

    {
      type: "box",
      size: [0.55, 3.4, 0.55],
      position: [0, 2.3, -2.2],
      material: "toriiWood",
    },
    {
      type: "box",
      size: [0.55, 3.4, 0.55],
      position: [0, 2.3, 2.2],
      material: "toriiWood",
    },
    {
      type: "box",
      size: [0.5, 0.45, 6],
      position: [0, 4.15, 0],
      material: "toriiWood",
    },
    {
      type: "box",
      size: [0.4, 0.35, 5],
      position: [0, 3.55, 0],
      material: "toriiWood",
    },

    { type: "lantern", position: [-10, 0, -10] },
    { type: "lantern", position: [10, 0, -10] },
    { type: "lantern", position: [-10, 0, 10] },
    { type: "lantern", position: [10, 0, 10] },

    { type: "box", size: [1.4, 1.4, 1.4], position: [13.5, 0.7, -7], material: "wood" },
    {
      type: "box",
      size: [1.4, 1.4, 1.4],
      position: [13.6, 2.1, -7.1],
      rotationY: 0.4,
      material: "wood",
    },
    { type: "box", size: [1.2, 1.2, 1.2], position: [-16, 0.6, 9], rotationY: 0.2, material: "wood" },
    {
      type: "box",
      size: [1.2, 1.2, 1.2],
      position: [-17.4, 0.6, 9.2],
      rotationY: -0.15,
      material: "wood",
    },
    { type: "box", size: [1.2, 1.2, 1.2], position: [7, 0.6, 16], rotationY: 0.5, material: "wood" },

    {
      type: "rock",
      position: [-11, 0.4, -13],
      scale: [1.7, 1.1, 2.3],
      rotationY: 0.7,
      material: "rock",
    },
    {
      type: "rock",
      position: [18, 0.4, 14],
      scale: [2.1, 1.2, 1.8],
      rotationY: -0.4,
      material: "rock",
    },
    {
      type: "rock",
      position: [2.5, 0.35, -18],
      scale: [1.4, 0.9, 1.6],
      rotationY: 1.9,
      material: "rock",
    },
    {
      type: "rock",
      position: [-19, 0.35, -4],
      scale: [1.5, 0.9, 1.7],
      rotationY: 0.3,
      material: "rock",
    },
  ],
};

export default zenGarden;
